export default "__VITE_ASSET__CqYPt1w6__"